import type { SimplePaletteColorOptions } from "@mui/material";
import type { HspThemeColors } from "web_myplann/Infrastructure/Themes/Colors";

export const getHspPrimaryColors = (
	color: HspThemeColors,
): Required<SimplePaletteColorOptions> => ({
	light: color.hspColor25 || color.Primary25,
	main: color.hspColor || color.Primary,
	dark: color.hspColor75 || color.Primary75,
	contrastText: color.White,
});
